import { Any } from "@cede/types";

/**
 * @description Get a nested object field value
 */
export function getNestedObjectFieldValue(obj: Any, path: string) {
  const pathArray = path.split(".");
  return pathArray.reduce((obj, key) => (obj && obj[key] !== "undefined" ? obj[key] : undefined), obj);
}

/**
 * @description Update a nested object field value without mutating the original object
 */
export function updateNestedObjectFieldValue(
  obj: Any,
  path: string,
  value: Any,
  opts: { removeIfUndefined?: boolean } = {},
) {
  const pathArray = path.split(".");
  const newObject = structuredClone(obj);
  let cursor = newObject;

  pathArray.forEach((key, index) => {
    if (index === pathArray.length - 1) {
      if (opts.removeIfUndefined && value === undefined) {
        delete cursor[key];
        return;
      }
      cursor[key] = value;
      return;
    }

    if (cursor[key] === undefined) {
      cursor[key] = {};
    }

    cursor = cursor[key];
  });

  return newObject;
}

/**
 * @description Construct a nested object from a flat object
 *
 * @paths - The paths to construct the nested object: it's a mapping of the flat object keys to the nested object paths
 * @data - The flat object
 *
 * @example
 * Given pathMapping { "d": "a.b.c": } and data { d : 5 }, it should construct { a: { b: { c: 5 } } }
 */
export function constructNestedObjectFromFlatObject(pathMapping: Record<string, string>, data: Record<string, Any>) {
  const keys = Object.keys(pathMapping);
  return keys.reduce((acc, key) => updateNestedObjectFieldValue(acc, pathMapping[key] || "", data[key]), {});
}
